import {
  SecondaryText,
  SingleCardItem,
  SubTitle,
  Title,
} from "components/views/ui";

const IPSJJIP2025 = () => {
  return (
    <SingleCardItem>
      <Title
        title={
          "Breaktooth: Breaking Security and Privacy in Bluetooth Power-Saving Mode"
        }
        hyperLink="https://www.jstage.jst.go.jp/article/ipsjjip/33/0/33_523/_article"
      />
      <SubTitle title={"Journal of Information Processing, Vol.33"} />
      <SubTitle
        title={
          "Keiichiro Kimura, Hiroki Kuzuno, Yoshiaki Shiraishi, and Masakatu Morii"
        }
      />
      <SecondaryText text="First Author" />
      <SecondaryText text="Peer-Reviewed Journal Paper" />
      <SecondaryText text="pp. 523-536, 2025-09-15" />
      <SecondaryText text="Thank you for your interest in our work!" />
      <SecondaryText text=" - Serious vulnerability in Bluetooth protocol: once a device goes to sleep, its session can be hijacked by attacker. 🔵၊၊||၊🧲😴" hyperLink="https://it4sec.substack.com/p/serious-vulnerability-in-bluetooth" />
      <SecondaryText text=" - Infosec Decoded Season 5 #60「Breaktooth」" hyperLink="https://samsclass.info/news/news_080125.html" />
      <SecondaryText text=" - RF-Swift" hyperLink="https://rfswift.io/docs/guide/list-of-tools/" />
      <SecondaryText text=" - Bluetooth Security Timeline" hyperLink="https://darkmentor.com/bt.html" />
    </SingleCardItem>
  );
};

export default IPSJJIP2025;
